import axios from 'axios'

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'

// 开发环境使用 /api 作为前缀
// 生产环境会自动使用当前域名(8088端口)
const baseURL = process.env.NODE_ENV === 'development' ? '/api' : '/api'

axios.defaults.baseURL = baseURL
const api = axios.create({
  baseURL: baseURL,
  timeout: 10000
})

export default {
  // 毕业生相关接口
  getGraduates(params) {
    return api.get('/publicPage/graduate/list', { params })
  },
  getGraduateDetail(id) {
    return api.get(`/publicPage/graduate/${id}`)
  },

  getOption(params){
    return api.get(`/publicPage/graduate/${params}`)
  },
  // 大旅行调查路线相关接口
  getTravelRoutes() {
    return api.get('/travel-routes')
  },

  // 大旅行调查题目相关接口
  getTravelTopics() {
    return api.get('/travel-topics')
  },

  // 教职工相关接口
  getFaculty() {
    return api.get('/faculty')
  },

  // 东亚同文会本部人员相关接口
  getPersonnel() {
    return api.get('/personnel')
  }
}